import React, { useEffect, useState, useCallback, useRef } from 'react';
import {
  View,
  Text,
  ScrollView,
  TouchableOpacity,
  StyleSheet,
  Platform,
  Modal,
  ActivityIndicator,
  Alert,
  Image,
  FlatList,
  TextInput,
  KeyboardAvoidingView,
} from 'react-native';
import { useBagStore } from '../../store/BagStore';
import { useScheduledProposalStore } from '../../store/ScheduledProposalStore';
import { useFocusEffect, useNavigation } from '@react-navigation/native';
import BagList from '../Bag/components/BagList/BagList';
import ButtonComponent from '../../components/ButtonComponent/ButtonComponent';
import { styles } from './styles';
import SearchHeader from '../../components/SearchHeader/SearchHeader';
import TemporaryPasswordBanner from '../../components/TemporaryPasswordBanner/TemporaryPasswordBanner';
import { useLoadingStore } from '../../store/LoadingStore';
import SalesService from '../../services/SalesService/SalesService';
import { useUserStore } from '../../store/UserStore';
import { Colors } from '../../constants/Colors';
import { AppRoutes } from '../../navigation/Routes.types';
import moment from 'moment';
import 'moment/locale/pt-br';
import ExtendedTermsModal from '../Bag/components/ExtendedTermsModal/ExtendedTermsModal';
import useExtendedTermsStore from '../../store/ExtendedTermsStore';
import { getAnalytics, logEvent } from '@react-native-firebase/analytics';
import DebtsService from '../../services/DebtsService/DebtsService';
import CardsService from '../../services/CardsService/CardsService';
import IoPayService from '../../services/IoPayService/IoPayService';
import { Images } from '../../constants/Images';
import { NavigationProps } from '../../navigation/Routes';
import LimitAlert from './components/LimitAlert/LimitAlert';
import NoInfoAlert from './components/NoInfoAlert/NoInfoAlert';
import { useLimitStore } from '../../store/LimitStore';
import { clientLimitsGet } from '../../services/ProductsService/ProductsService';
import { showInfo } from '../../utils/globalAlert';
// import {Picker} from '@react-native-picker/picker'; // Comentado - não usado mais

moment.locale('pt-br');

const Checkout = () => {
  const navigation = useNavigation();
  const { goBack } = useNavigation();
  const { navigate, replace } = useNavigation<NavigationProps>();
  const products = useBagStore(state => state.products);
  const totalPrice = useBagStore(state => state.getTotalPrice());
  const totalItems = useBagStore(state => state.getTotalItems());
  const {showLoading, hideLoading} = useLoadingStore();
  const {clearCart} = useBagStore();
  const {user} = useUserStore();
  const temporaryPasswordLogin = useUserStore(state => state.temporaryPasswordLogin);
  const analyticsInstance = getAnalytics();

  // Estados para métodos de pagamento
  const [loading, setLoading] = useState<boolean>(false);
  const [pixAvailable, setPixAvailable] = useState<boolean>(false);
  const [creditAvailable, setCreditAvailable] = useState<boolean>(false);
  const [boletoAvailable, setBoletoAvailable] = useState<boolean>(false);
  const [selectedMethod, setSelectedMethod] = useState<string | null>('');
  const [selectedCard, setSelectedCard] = useState<any>(null);
  const [cards, setCards] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [iopayError, setIopayError] = useState<boolean>(false);
  const iopayLoadedRef = useRef(false);

  // ========== PARCELAMENTO COMENTADO - FIXO EM 1X ==========
  const installments = 1; // Sempre 1x - não permite alteração
  // =========================================================

  // Estados para customer
  const [showCustomerModal, setShowCustomerModal] = useState(false);
  const [customerName, setCustomerName] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerCep, setCustomerCep] = useState('');
  const [customerAddress, setCustomerAddress] = useState('');
  const [customerCity, setCustomerCity] = useState('');
  const [customerState, setCustomerState] = useState('');
  const [loadingCep, setLoadingCep] = useState(false);
  const [customerFieldErrors, setCustomerFieldErrors] = useState<
    Record<string, string | undefined>
  >({});
  const estadosValidos = [
    'AC',
    'AL',
    'AP',
    'AM',
    'BA',
    'CE',
    'DF',
    'ES',
    'GO',
    'MA',
    'MT',
    'MS',
    'MG',
    'PA',
    'PB',
    'PR',
    'PE',
    'PI',
    'RJ',
    'RN',
    'RS',
    'RO',
    'RR',
    'SC',
    'SP',
    'SE',
    'TO',
  ];

  const bypassDuplicateRef = useRef(false);
  const [showDuplicateModal, setShowDuplicateModal] = useState(false);

  // Estados existentes
  const [disableButton, setDisableButton] = useState<boolean>(false);
  const [isExtendedTermsModalVisible, setExtendedTermsModalVisible] =
    useState(false);
  const [deliveryDate, setDeliveryDate] = useState<string | null>(null);
  const [loadingDeliveryDate, setLoadingDeliveryDate] =
    useState<boolean>(false);

  const { balance, minOrder, setLimit, setMinOrder, setBalance } =
    useLimitStore();
  const [loadingLimit, setLoadingLimit] = useState<boolean>(false);

  // Rebusca o limite/saldo ao entrar no Checkout: não confiamos no valor em
  // cache (AsyncStorage), que pode estar defasado em relação ao saldo real.
  const refreshLimits = useCallback(async () => {
    if (!user?.clientCode) return;
    setLoadingLimit(true);
    try {
      const response = await clientLimitsGet(user?.clientCode);
      setLimit(response.Limitecredito ?? null);
      setMinOrder(response.Minimoorder ?? null);
      setBalance(response.Saldodisponivel ?? null);
    } catch (error) {
      console.error('Erro ao atualizar limite no checkout:', error);
      // Sem dado confiável, zeramos o saldo para que a trava do boleto bloqueie
      // a compra em vez de liberar por engano.
      setBalance(null);
    } finally {
      setLoadingLimit(false);
    }
  }, [user?.clientCode, setLimit, setMinOrder, setBalance]);

  // Boleto só é liberado com saldo carregado e suficiente. Usamos `== null`
  // de propósito: cobre tanto null quanto undefined, evitando que
  // `totalPrice > undefined` (=> NaN => false) deixe a compra passar.
  const insufficientBoletoLimit =
    selectedMethod === 'boleto' &&
    (loadingLimit || balance == null || totalPrice > balance);

  const {
    data: extendedTerms,
    loading: extendedTermsLoading,
    error: extendedTermsError,
  } = useExtendedTermsStore();
  const [percentage, setPercentage] = React.useState(0);
  const [remaining, setRemaining] = React.useState(0);
  const [days, setDays] = React.useState(0);

  const validateEmail = (email: string) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const handleCepChange = (text: string) => {
    const cleaned = text.replace(/\D/g, '').slice(0, 8);
    let formatted = cleaned;
    if (cleaned.length >= 6) {
      formatted = cleaned.slice(0, 5) + '-' + cleaned.slice(5);
    }
    setCustomerCep(formatted);

    if (cleaned.length === 8) {
      consultarCep(cleaned);
    }
  };

  const consultarCep = async (cepNumeros: string) => {
    setLoadingCep(true);
    try {
      const response = await fetch(
        `https://viacep.com.br/ws/${cepNumeros}/json/`,
      );
      const data = await response.json();

      if (data.erro) {
        Alert.alert('CEP não encontrado', 'Verifique o CEP informado');
        return;
      }

      setCustomerAddress(data.logradouro || '');
      setCustomerCity(data.localidade || '');
      setCustomerState(data.uf || '');

      if (!data.logradouro) {
        showInfo(
          'Endereço incompleto',
          'CEP encontrado, mas é necessário completar o endereço manualmente',
        );
      }
    } catch (error) {
      console.error('Erro ao consultar CEP:', error);
      Alert.alert(
        'Erro ao consultar CEP',
        'Não foi possível consultar o CEP. Verifique sua conexão com a internet.',
      );
    } finally {
      setLoadingCep(false);
    }
  };

  const formatCPF = (cpf: string) => {
    return cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
  };

  const formatCNPJ = (cnpj: string) => {
    return cnpj.replace(
      /(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/,
      '$1.$2.$3/$4-$5',
    );
  };

  const formatTaxpayerId = (taxpayerId: string) => {
    if (taxpayerId.length === 11) {
      return formatCPF(taxpayerId);
    } else if (taxpayerId.length === 14) {
      return formatCNPJ(taxpayerId);
    }
    return taxpayerId;
  };

  const checkCustomerStatus = async (): Promise<'found' | 'not_found' | 'error'> => {
    try {
      const result = await Promise.race([
        CardsService.GetCustomer(
          user?.current_client?.clientCode ?? user?.clientCode,
        ),
        new Promise<never>((_, reject) =>
          setTimeout(() => reject(new Error('timeout')), 8000),
        ),
      ]);
      return result?.customer ? 'found' : 'not_found';
    } catch (error) {
      console.error('IoPay customer check failed:', error);
      return 'error';
    }
  };

  const loadIoPayData = async () => {
    if (iopayLoadedRef.current) {
      setIsModalVisible(true);
      return;
    }
    setLoading(true);
    try {
      const status = await checkCustomerStatus();

      if (status === 'error') {
        setIopayError(true);
        setIsModalVisible(true);
        return;
      }

      if (status === 'not_found') {
        setShowCustomerModal(true);
        return;
      }

      const token = await authenticate();
      const cardsResponse = await CardsService.GetCards(
        user?.current_client?.clientCode ?? user?.clientCode,
        token,
      );
      const cardsData = cardsResponse.cards;
      const cardImages: {[key: string]: any} = {
        Visa: Images.visaIcon,
        MasterCard: Images.masterCardIcon,
      };
      const mappedCards = cardsData.items.map((card: any) => ({
        id: card.id_card,
        brand: card.card_brand,
        type: 'Crédito',
        lastDigits: card.last4_digits,
        isFavorite: cardsData.default_debit?.id_card === card.id_card,
        image: cardImages[card.card_brand] || '',
      }));
      setCards(mappedCards);
      iopayLoadedRef.current = true;
      setIsModalVisible(true);
    } catch (error) {
      setIopayError(true);
      setIsModalVisible(true);
    } finally {
      setLoading(false);
    }
  };

  const handleCreateCustomer = async () => {
    if (!customerName.trim()) {
      setCustomerFieldErrors(prev => ({ ...prev, name: 'Preencha o nome.' }));
      Alert.alert('Erro', 'Por favor, preencha o nome.');
      return;
    }

    if (!customerEmail.trim()) {
      setCustomerFieldErrors(prev => ({ ...prev, email: 'Preencha o email.' }));
      Alert.alert('Erro', 'Por favor, preencha o email.');
      return;
    }

    if (!validateEmail(customerEmail)) {
      setCustomerFieldErrors(prev => ({ ...prev, email: 'Email inválido.' }));
      Alert.alert('Erro', 'Por favor, insira um email válido.');
      return;
    }

    if (!customerCep || !customerAddress || !customerCity || !customerState) {
      setCustomerFieldErrors(prev => ({
        ...prev,
        cep: !customerCep ? 'Campo obrigatório.' : prev.cep,
        address: !customerAddress ? 'Campo obrigatório.' : prev.address,
        city: !customerCity ? 'Campo obrigatório.' : prev.city,
        uf: !customerState ? 'Campo obrigatório.' : prev.uf,
      }));
      Alert.alert('Erro', 'Preencha todos os campos obrigatórios.');
      return;
    }

    if (!estadosValidos.includes(customerState)) {
      setCustomerFieldErrors(prev => ({ ...prev, uf: 'UF inválido.' }));
      Alert.alert('Erro', 'UF inválido.');
      return;
    }

    const client = user?.current_client;

    if (!client) {
      Alert.alert('Erro', 'Cliente não encontrado.');
      return;
    }

    setCustomerFieldErrors({});

    try {
      setLoading(true);

      const data = {
        client_code: user?.current_client?.clientCode ?? user?.clientCode,
        first_name: customerName.trim(),
        email: customerEmail.trim().toLowerCase(),
        taxpayer_id: formatTaxpayerId(client.cnpj_cpf),
        address: {
          city: customerCity,
          state: customerState,
          line1: customerAddress,
        },
      };

      await CardsService.CreateCustomer(data);
      setShowCustomerModal(false);

      setLoading(false);
      loadIoPayData();
    } catch (error) {
      setLoading(false);
      Alert.alert('Erro', 'Não foi possível criar o customer.');
    }
  };

  const authenticate = async () => {
    const response = await IoPayService.IoPayAuth();
    return response.access_token;
  };

  /**
   * PAG-01 — a sacola veio de um PEDIDO A PAGAR?
   *
   * Quando sim, o checkout oferece PIX e cartão, SEM BOLETO. Isso não é uma
   * limitação de tela: o backend recusa o boleto para o à vista com 422,
   * porque ele marca o pedido como enviado na confirmação do PEDIDO, não do
   * pagamento, e faria o Conecta Sales anunciar ao vendedor um pagamento que
   * nunca aconteceu. PIX e cartão só viram pedido depois de a IOPAY confirmar.
   *
   * Lido do store, e não de parâmetro de navegação, pela mesma razão do
   * `proposalId`: precisa sobreviver a Sacola -> Checkout -> escolha do meio.
   */
  const semBoleto =
    useScheduledProposalStore(estado => estado.paymentMode) === 'A_VISTA';

  const loadInitialMethods = useCallback(async () => {
    setIopayError(false);
    setLoading(true);
    try {
      const methodsResponse = await DebtsService.GetPaymentMethods();
      if (methodsResponse) {
        const activeMethods = methodsResponse.data.filter(
          (method: any) => method.is_active === 1 && method.usage === 'sales',
        );

        // O corte do à vista vem DEPOIS da disponibilidade, nunca antes: se o
        // PIX e o cartão estiverem desligados no painel, o pedido à vista fica
        // sem meio de pagamento — e isso precisa aparecer como "indisponível"
        // em vez de oferecer um botão que o backend vai recusar.
        const hasPix = activeMethods.some((m: any) => m.name === 'pix');
        const hasCredit = activeMethods.some(
          (m: any) => m.name === 'credit_card',
        );
        const hasBoleto =
          !semBoleto && activeMethods.some((m: any) => m.name === 'boleto');

        setPixAvailable(hasPix);
        setCreditAvailable(hasCredit);
        setBoletoAvailable(hasBoleto);

        if (hasBoleto) {
          setSelectedMethod('boleto');
          setSelectedCard(null);
        } else if (hasPix) {
          setSelectedMethod('pix');
          setSelectedCard(null);
        } else if (hasCredit) {
          setSelectedMethod('credit_card');
        }
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  }, [semBoleto]);

  const getDeliveryDate = async () => {
    setLoadingDeliveryDate(true);
    try {
      const response = await SalesService.DeliveryDateGet(
        user?.current_client?.clientCode ?? user?.clientCode,
      );

      const rawDate = response.data;
      const formattedDate = moment(rawDate, 'DD/MM/YYYY').format(
        'DD/MM/YYYY (dddd)',
      );
      setDeliveryDate(formattedDate);
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingDeliveryDate(false);
    }
  };

  useEffect(() => {
    getDeliveryDate();
  }, []);

  useFocusEffect(
    useCallback(() => {
      iopayLoadedRef.current = false;
      loadInitialMethods();
      refreshLimits();
    }, [loadInitialMethods, refreshLimits]),
  );

  useEffect(() => {
    if (totalPrice > 0) {
      const quota = extendedTerms?.value || 0;
      setPercentage(Math.min((totalPrice / quota) * 100, 100));
      setRemaining(Math.max(quota - totalPrice, 0));
      setDays(extendedTerms?.days || 0);
    }
  }, [totalPrice]);

  const handleSelectMethod = (method: string, card?: any) => {
    setSelectedMethod(method);
    if (method === 'credit_card' && card) {
      setSelectedCard(card);
    } else {
      setSelectedCard(null);
    }
    setIsModalVisible(false);
  };

  // confirmar envio após modal de duplicata
  const handleConfirmDuplicate = () => {
    setShowDuplicateModal(false);
    bypassDuplicateRef.current = true;
    handleNavigateOrderSent(
      user?.current_client?.clientCode ?? user?.clientCode,
    );
  };

  // recusar → não envia ao SAP, volta para home sem limpar carrinho
  const handleRefuseDuplicate = () => {
    setShowDuplicateModal(false);
    clearCart();
    (navigate as any)(AppRoutes.MAIN_TAB_SCREEN, { screen: 'Home' });
  };

  const handleNavigateOrderSent = async (clientCode: string) => {
    try {
      const version = Platform.Version;
      const platform = Platform.OS;
      logEvent(analyticsInstance, 'checkout_click', {
        client_code: clientCode,
        platform: platform,
        version: version,
      });
      showLoading();
      const productsInCart = useBagStore.getState().products;

      if (productsInCart.some(product => product.fromBanner === true)) {
        logEvent(analyticsInstance, 'checkout_banner_item', {
          client_code: clientCode,
          platform: platform,
          version: version,
          product: productsInCart
            .filter(product => product.fromBanner === true)
            .map(product => product.sku)
            .join(', '),
        });
      }

      const productslist = productsInCart.map(product => {
        const lineAmount = product.discountedPrice * product.quantity;
        return {
          name: product.descricao,
          code: product.sku,
          quantity: product.quantity,
          amount: lineAmount,
          tabela_combo: product?.KVGR1 || product?.kvgr1 || null,
        };
      });

      const data = {
        client_code: clientCode,
        card_id: selectedCard?.id,
        reference_type: 'order',
        description: 'Compra no PIX - Conecta Brasal',
        statement_descriptor: 'Conecta Brasal',
        installments: installments,
        products: productslist,
      };

      // Header para bypassar verificação de duplicata no backend
      const forceDuplicate: Record<string, string> = bypassDuplicateRef.current
        ? {'X-Force-Duplicate': 'true'}
        : {};
      bypassDuplicateRef.current = false;

      // CB-4: marca o pedido como aceite de um pedido programado. O backend só
      // avisa o Conecta Sales quando o pedido é confirmado de fato — por isso o
      // vínculo viaja junto da criação, e não numa chamada à parte.
      const proposalId = useScheduledProposalStore.getState().proposalId;
      const proposalHeader: Record<string, string> = proposalId
        ? {'X-Proposal-Id': proposalId}
        : {};

      // Pedido sugerido: a sacola foi enchida pelo sugerido. O backend compara
      // com o retrato e marca o pedido como sugerido inteiro ou parcial.
      const suggestedFillId = useBagStore.getState().suggestedFillId;
      const suggestedFillHeader: Record<string, string> = suggestedFillId
        ? {'X-Suggested-Fill-Id': suggestedFillId}
        : {};

      const extraHeaders = {
        ...forceDuplicate,
        ...proposalHeader,
        ...suggestedFillHeader,
      };
      const forceDuplicateHeaders: Record<string, string> | undefined =
        Object.keys(extraHeaders).length > 0 ? extraHeaders : undefined;

      switch (selectedMethod) {
        case 'pix':
          // PAG-01 — o pedido à vista passa por aqui ou pelo cartão. O que o
          // impede de chegar no boleto é `semBoleto`, que nunca deixa
          // `selectedMethod` virar boleto — e, se chegar (app antigo, chamada
          // direta), o backend responde 422.

          let pixResponse = await SalesService.PixOrderPost(
            data,
            forceDuplicateHeaders,
          );
          navigation.navigate(AppRoutes.ORDER_SENT_PIX, pixResponse);
          break;
        case 'credit_card':
          let creditResponse = await SalesService.CreditCardOrderPost(
            data,
            forceDuplicateHeaders,
          );

          navigation.navigate(AppRoutes.ORDER_SENT, {
            ...creditResponse,
            type: 'credit_card',
          });
          break;
        case 'boleto':
          const productsForPost = productsInCart.map(product => ({
            sku: product.sku,
            total: product.quantity,
            usePrice: product.discountedPrice
              ? product.discountedPrice
              : product.preco,
            faixaVolume5: '0',
            faixaVolume4: '0',
            faixaVolume3: '0',
            faixaVolume2: '0',
            KVGR1: product?.KVGR1 || product?.kvgr1,
          }));

          let ticketResponse = await SalesService.TicketOrderPost(
            productsForPost,
            clientCode,
            forceDuplicateHeaders,
          );
          navigation.navigate(AppRoutes.ORDER_SENT, {
            ...ticketResponse,
            type: 'ticket',
          });
          break;
        default:
          Alert.alert('Erro', 'Método de pagamento não inválido');
          break;
      }
      clearCart();
      // Sem isto o PRÓXIMO pedido do cliente sairia marcado como aceite de uma
      // proposta que ele já respondeu.
      useScheduledProposalStore.getState().clear();
    } catch (error) {
      if (
        error?.response?.status === 409 &&
        error?.response?.data?.duplicate === true
      ) {
        if (Platform.OS === 'ios') {
          setTimeout(() => {
            setDisableButton(false);
            hideLoading();
            setTimeout(() => {
              setShowDuplicateModal(true);
            }, 500);
          }, 500);
        } else {
          setDisableButton(false);
          hideLoading();
          setShowDuplicateModal(true);
        }
        return;
      }
      // error.response e um objeto axios (config/request/headers) que o
      // react-navigation nao consegue serializar para a URL no web
      // (getPathFromState -> String(param) -> "Cannot convert object to
      // primitive value"). Passa apenas os campos serializaveis que a tela usa.
      navigation.navigate(AppRoutes.ORDER_SENT, {
        data: {
          message: error?.response?.data?.message,
          details: error?.response?.data?.details,
        },
      });
    } finally {
      if (Platform.OS === 'ios') {
        setTimeout(() => {
          hideLoading();
        }, 500);
      } else {
        hideLoading();
      }
    }
  };

  const paymentFee = selectedMethod === 'boleto' ? 5 : 0;
  const totalWithFee = totalPrice + paymentFee;

  function formatCurrency(value: number): string {
    return value.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2,
    });
  }

  const renderItem = ({ item }: any) => (
    <TouchableOpacity onPress={() => handleSelectMethod('credit_card', item)}>
      <View style={design.card}>
        {item.image && <Image source={item.image} style={design.cardImage} />}
        <View style={design.cardInfo}>
          <Text style={design.cardTitle}>{`${item.brand} - ${item.type}`}</Text>
          <Text style={design.cardNumber}>**** {item.lastDigits}</Text>
        </View>
      </View>
    </TouchableOpacity>
  );

  return (
    <>
      <View style={{ flex: 1, backgroundColor: '#fff' }}>
        <SearchHeader
          onPress={() => navigate(AppRoutes.BAG)}
          title="Confirmação de compra"
          mt={20}
          mb={20}
          ph={20}
        />
        <TemporaryPasswordBanner />

        {loading && (
          <View style={{ padding: 16 }}>
            <ActivityIndicator size="large" color="#000" />
          </View>
        )}

        <ScrollView style={{ paddingVertical: 10, paddingHorizontal: 20 }}>
          {selectedMethod === 'boleto' &&
            !loadingLimit &&
            balance == null && (
              <NoInfoAlert
                getLimits={refreshLimits}
                loadingLimit={loadingLimit}
              />
            )}

          {selectedMethod === 'boleto' &&
            balance !== null &&
            totalPrice > balance && <LimitAlert balance={balance} />}

          <View style={design.paymentSection}>
            <Text style={design.paymentHeader}>Forma de Pagamento</Text>

            {selectedMethod && (
              <View style={design.paymentRow}>
                {selectedMethod === 'credit_card' && selectedCard && (
                  <>
                    {selectedCard.image && (
                      <Image
                        source={selectedCard.image}
                        style={design.cardImage}
                      />
                    )}
                    <View style={design.cardInfo}>
                      <Text style={design.cardTitle}>
                        {`${selectedCard.brand} - ${selectedCard.type}`}
                      </Text>
                      <Text style={design.cardNumber}>
                        **** {selectedCard.lastDigits}
                      </Text>
                    </View>
                  </>
                )}
                {selectedMethod === 'pix' && (
                  <>
                    <Image source={Images.pixIcon} style={design.cardImage} />
                    <View style={design.cardInfo}>
                      <Text style={design.cardTitle}>Pix</Text>
                    </View>
                  </>
                )}
                {selectedMethod === 'boleto' && (
                  <>
                    <Image
                      source={Images.boletoIcon}
                      style={design.cardImage}
                    />
                    <View style={design.cardInfo}>
                      <Text style={design.cardTitle}>Boleto</Text>
                    </View>
                  </>
                )}
                <TouchableOpacity
                  onPress={() => {
                    if (iopayError) {
                      setIsModalVisible(true);
                      return;
                    }
                    loadIoPayData();
                  }}
                  disabled={loading}>
                  <Text style={design.changeButton}>Trocar</Text>
                </TouchableOpacity>
              </View>
            )}

            {paymentFee > 0 && (
              <View style={styles.containerSubtotal}>
                <Text style={styles.subtotalText}>Taxa administrativa</Text>
                <Text style={styles.priceText}>
                  {paymentFee.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })}
                </Text>
              </View>
            )}
          </View>
          {products.map((item, index) => (
            <BagList
              key={(item as any).cartKey ?? item.sku}
              item={item}
              index={index}
              complete={false}
            />
          ))}

          <View style={design.deliverySection}>
            <Text style={design.deliveryHeader}>Entrega</Text>
            <Text style={design.deliveryText}>Grátis</Text>
            {loadingDeliveryDate ? (
              <Text style={design.deliveryDate}>
                Carregando provável data de entrega...
              </Text>
            ) : deliveryDate ? (
              <Text style={design.deliveryDate}>
                Provável data de entrega: {deliveryDate}
              </Text>
            ) : (
              <Text style={design.deliveryDate}>
                Provável data de entrega não disponível.
              </Text>
            )}
          </View>

          <View style={styles.containerSummary}>
            <Text style={styles.summaryText}>Resumo</Text>
            <Text style={styles.quantityText}>{totalItems} itens</Text>
          </View>
          <View style={styles.containerSubtotal}>
            <Text style={styles.subtotalText}>Subtotal</Text>
            <Text style={styles.priceText}>
              {totalPrice.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Text>
          </View>

          <View style={styles.containerTotal}>
            <Text style={styles.totalText}>Total a pagar</Text>
            <Text style={styles.totalPrice}>
              {totalWithFee.toLocaleString('pt-BR', {
                style: 'currency',
                currency: 'BRL',
              })}
            </Text>
          </View>

          <View style={styles.containerButton}>
            <ButtonComponent
              title={
                selectedMethod === 'pix'
                  ? 'Ir para pagamento'
                  : 'Finalizar Compra'
              }
              disabled={
                disableButton ||
                !selectedMethod ||
                insufficientBoletoLimit ||
                temporaryPasswordLogin
              }
              onPress={() => {
                if (products.length > 0) {
                  setDisableButton(true);
                  if (
                    extendedTerms &&
                    !extendedTermsError &&
                    remaining > 0 &&
                    selectedMethod === 'boleto'
                  ) {
                    setExtendedTermsModalVisible(true);
                  } else {
                    handleNavigateOrderSent(
                      user?.current_client?.clientCode ?? user?.clientCode,
                    );
                  }
                }
              }}
              width="100%"
            />
            <ButtonComponent
              title="Voltar"
              outlined
              onPress={() => {
                navigation.navigate(AppRoutes.BAG);
              }}
              width="100%"
            />
          </View>
        </ScrollView>
      </View>

      {/* Modal de seleção de pagamento */}
      <Modal visible={isModalVisible} transparent animationType="slide">
        <View style={design.modalBackdrop}>
          <View style={design.modalContent}>
            <Text style={design.modalTitle}>
              Escolha uma forma de pagamento
            </Text>

            {iopayError && (
              <Text style={{fontSize: 13, color: '#888', textAlign: 'center', marginBottom: 12}}>
                PIX e cartão indisponíveis no momento.
              </Text>
            )}

            {pixAvailable && !iopayError && (
              <TouchableOpacity onPress={() => handleSelectMethod('pix', null)}>
                <View style={design.pixCard}>
                  <Image source={Images.pixIcon} style={design.cardImage} />
                  <View style={design.cardInfo}>
                    <Text style={design.cardTitle}>Pix</Text>
                  </View>
                </View>
              </TouchableOpacity>
            )}

            {boletoAvailable && (
              <TouchableOpacity
                onPress={() => handleSelectMethod('boleto', null)}>
                <View style={design.pixCard}>
                  <Image source={Images.boletoIcon} style={design.cardImage} />
                  <View style={design.cardInfo}>
                    <Text style={design.cardTitle}>Boleto</Text>
                  </View>
                </View>
              </TouchableOpacity>
            )}

            {creditAvailable && !iopayError && (
              <>
                <FlatList
                  data={cards}
                  renderItem={renderItem}
                  keyExtractor={item => item.id}
                  contentContainerStyle={design.listContent}
                />

                <TouchableOpacity
                  style={{
                    backgroundColor: Colors.RedPallete.red,
                    padding: 12,
                    borderRadius: 8,
                    alignItems: 'center',
                    marginTop: 10,
                  }}
                  onPress={() => {
                    setIsModalVisible(false);
                    navigate(AppRoutes.NEW_CARD);
                  }}>
                  <Text style={{ color: '#fff', fontWeight: '600' }}>
                    + Novo cartão
                  </Text>
                </TouchableOpacity>
              </>
            )}

            <TouchableOpacity
              onPress={() => setIsModalVisible(false)}
              style={{ marginTop: 12 }}>
              <Text style={{ textAlign: 'center', color: '#666' }}>Cancelar</Text>
            </TouchableOpacity>
          </View>
        </View>
      </Modal>

      {/* Modal de Extended Terms */}
      <ExtendedTermsModal
        visible={isExtendedTermsModalVisible}
        onRequestClose={() => setExtendedTermsModalVisible(false)}
        onConfirm={() => {
          setExtendedTermsModalVisible(false);
          handleNavigateOrderSent(
            user?.current_client?.clientCode ?? user?.clientCode,
          );
        }}
        remaining={remaining}
        days={days}
      />

      {/* Modal de confirmação de pedido duplicado */}
      <Modal visible={showDuplicateModal} transparent animationType="fade">
        <View style={design.modalBackdrop}>
          <View style={design.modalContent}>
            <Text style={design.modalTitle}>
              Você já possui um pedido como este feito hoje. Deseja realizá-lo
              novamente?
            </Text>
            <ButtonComponent
              title="Sim, realizar novamente"
              onPress={handleConfirmDuplicate}
              width="100%"
            />
            <View style={{ marginTop: 12 }}>
              <ButtonComponent
                title="Não"
                outlined
                onPress={handleRefuseDuplicate}
                width="100%"
              />
            </View>
          </View>
        </View>
      </Modal>


      {/* MODAL DE CADASTRO DE CUSTOMER CORRIGIDA */}
      <Modal visible={showCustomerModal} transparent animationType="slide">
        <KeyboardAvoidingView
          behavior={Platform.OS === 'ios' ? 'padding' : 'height'}
          style={design.modalBackdrop}>
          <TouchableOpacity
            activeOpacity={1}
            style={design.customerModalContainer}
            onPress={() => { }}>
            <View style={design.customerModalContent}>
              <ScrollView
                showsVerticalScrollIndicator={false}
                keyboardShouldPersistTaps="handled">
                <Text style={design.modalTitle}>
                  Complete seus dados para a primeira compra
                </Text>

                <TextInput
                  style={[
                    design.input,
                    customerFieldErrors.name && { borderColor: 'red' },
                  ]}
                  placeholder="Nome completo"
                  placeholderTextColor="#999"
                  value={customerName}
                  onChangeText={text => {
                    setCustomerName(text);
                    if (customerFieldErrors.name) {
                      setCustomerFieldErrors(prev => ({ ...prev, name: undefined }));
                    }
                  }}
                />
                {customerFieldErrors.name && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.name}
                  </Text>
                )}

                <TextInput
                  style={[
                    design.input,
                    customerFieldErrors.email && { borderColor: 'red' },
                  ]}
                  placeholder="Email"
                  placeholderTextColor="#999"
                  keyboardType="email-address"
                  autoCapitalize="none"
                  value={customerEmail}
                  onChangeText={text => {
                    setCustomerEmail(text);
                    if (customerFieldErrors.email) {
                      setCustomerFieldErrors(prev => ({ ...prev, email: undefined }));
                    }
                  }}
                />
                {customerEmail && !validateEmail(customerEmail) && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    Email inválido
                  </Text>
                )}
                {!customerEmail && customerFieldErrors.email && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.email}
                  </Text>
                )}

                <View style={{ position: 'relative' }}>
                  <TextInput
                    style={[
                      design.input,
                      customerFieldErrors.cep && { borderColor: 'red' },
                    ]}
                    placeholder="CEP"
                    placeholderTextColor="#999"
                    keyboardType="numeric"
                    maxLength={9}
                    value={customerCep}
                    onChangeText={text => {
                      handleCepChange(text);
                      if (customerFieldErrors.cep) {
                        setCustomerFieldErrors(prev => ({ ...prev, cep: undefined }));
                      }
                    }}
                  />
                  {loadingCep && (
                    <View style={{ position: 'absolute', right: 12, top: 12 }}>
                      <ActivityIndicator size="small" color="#666" />
                    </View>
                  )}
                </View>
                {customerFieldErrors.cep && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.cep}
                  </Text>
                )}

                <TextInput
                  style={[
                    design.input,
                    customerFieldErrors.address && { borderColor: 'red' },
                  ]}
                  placeholder="Endereço"
                  placeholderTextColor="#999"
                  value={customerAddress}
                  onChangeText={text => {
                    setCustomerAddress(text);
                    if (customerFieldErrors.address) {
                      setCustomerFieldErrors(prev => ({ ...prev, address: undefined }));
                    }
                  }}
                />
                {customerFieldErrors.address && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.address}
                  </Text>
                )}
                <TextInput
                  style={[
                    design.input,
                    customerFieldErrors.city && { borderColor: 'red' },
                  ]}
                  placeholder="Cidade"
                  placeholderTextColor="#999"
                  value={customerCity}
                  onChangeText={text => {
                    setCustomerCity(text);
                    if (customerFieldErrors.city) {
                      setCustomerFieldErrors(prev => ({ ...prev, city: undefined }));
                    }
                  }}
                />
                {customerFieldErrors.city && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.city}
                  </Text>
                )}
                <TextInput
                  style={[
                    design.input,
                    customerFieldErrors.uf && { borderColor: 'red' },
                  ]}
                  placeholder="Estado (UF)"
                  placeholderTextColor="#999"
                  value={customerState}
                  onChangeText={text => {
                    setCustomerState(text.toUpperCase());
                    if (customerFieldErrors.uf) {
                      setCustomerFieldErrors(prev => ({ ...prev, uf: undefined }));
                    }
                  }}
                  maxLength={2}
                />
                {customerState && !estadosValidos.includes(customerState) && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    UF inválido
                  </Text>
                )}
                {!customerState && customerFieldErrors.uf && (
                  <Text
                    style={{
                      color: 'red',
                      marginTop: -8,
                      marginBottom: 8,
                      fontSize: 12,
                    }}>
                    {customerFieldErrors.uf}
                  </Text>
                )}

                <ButtonComponent
                  title="Salvar"
                  disabled={loading || loadingCep}
                  onPress={() => {
                    if (!loading && !loadingCep) handleCreateCustomer();
                  }}
                  width="100%"
                />

                <TouchableOpacity
                  onPress={() => {
                    if (!loading && !loadingCep) {
                      setShowCustomerModal(false);
                      replace(AppRoutes.BAG);
                    }
                  }}>
                  <Text
                    style={{
                      textAlign: 'center',
                      color: '#666',
                      marginTop: 12,
                      paddingBottom: 20,
                    }}>
                    Cancelar
                  </Text>
                </TouchableOpacity>
              </ScrollView>
            </View>
          </TouchableOpacity>
        </KeyboardAvoidingView>
      </Modal>
    </>
  );
};

const design = StyleSheet.create({
  paymentSection: {
    marginTop: 20,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
  },
  paymentHeader: {
    fontSize: 16,
    marginBottom: 8,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  paymentRow: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#fff',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
  },
  deliverySection: {
    marginTop: 20,
    paddingVertical: 10,
    paddingHorizontal: 12,
    backgroundColor: '#F5F5F5',
    borderRadius: 8,
  },
  deliveryHeader: {
    fontSize: 16,
    marginBottom: 8,
    color: 'black',
    fontFamily: 'TCCC-UnityHeadline Regular',
  },
  deliveryText: {
    fontSize: 14,
    color: Colors.GreenPallete.greenOne,
    fontFamily: 'TCCC-UnityText Regular',
  },
  deliveryDate: {
    fontSize: 14,
    color: 'black',
    fontFamily: 'TCCC-UnityText Regular',
  },
  card: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8f8f8',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
  },
  pixCard: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: '#f8f8f8',
    padding: 12,
    borderRadius: 8,
    marginBottom: 8,
  },
  cardImage: {
    width: 40,
    height: 40,
    marginRight: 12,
    resizeMode: 'contain',
  },
  cardInfo: {
    flex: 1,
  },
  cardTitle: {
    fontSize: 14,
    fontWeight: '600',
    color: '#222',
  },
  cardNumber: {
    fontSize: 12,
    color: '#666',
    marginTop: 2,
  },
  changeButton: {
    color: Colors.RedPallete.red,
    fontWeight: '600',
    fontSize: 14,
  },
  modalBackdrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    justifyContent: 'center',
    alignItems: 'center',
  },
  modalContent: {
    backgroundColor: '#fff',
    width: '90%',
    maxHeight: '80%',
    borderRadius: 12,
    padding: 20,
  },
  modalTitle: {
    fontSize: 18,
    fontWeight: '700',
    color: '#222',
    marginBottom: 16,
    textAlign: 'center',
  },
  listContent: {
    paddingBottom: 10,
  },
  input: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 8,
    padding: 12,
    marginBottom: 12,
    fontSize: 14,
    color: '#222',
  },
  // NOVOS ESTILOS PARA MODAL DE CUSTOMER
  customerModalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    paddingHorizontal: 20,
  },
  customerModalContent: {
    width: '100%',
    maxWidth: 400,
    maxHeight: '85%',
    backgroundColor: '#fff',
    borderRadius: 12,
    padding: 20,
  },
});

export default Checkout;
